import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { TenantConfigProvider } from './contexts/TenantConfigContext';
import AuditLogin from './pages/AuditLogin';
import SelfAuditDashboard from './pages/SelfAuditDashboard';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#EEF1F6', fontFamily: "'Source Sans 3', sans-serif" }}>
        <div className="animate-pulse" style={{ color: '#8B95A1' }}>Loading...</div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<AuditLogin />} />
      <Route path="/" element={<ProtectedRoute><SelfAuditDashboard /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <TenantConfigProvider>
          <AppRoutes />
        </TenantConfigProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
